export default __webpack_public_path__ + "static/media/se.ce0b6c29.svg";